var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "addFormBox" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("basicData.UnderlyingData"))),
          ]),
          _c(
            "el-form",
            {
              ref: "queryForm",
              attrs: {
                size: "small",
                rules: _vm.rules,
                model: _vm.formData,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "basicData.TheNameOfTheQuoteProposal"
                            ),
                            prop: "name",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("orderDetails.pleaseInput"),
                              clearable: "",
                              maxlength: "100",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.formData.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.TheValidityPeriodBegins"),
                            prop: "startOfValidityPeriod",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              format:
                                _vm.$i18n.locale === "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              disabled: _vm.isDisableData,
                              "picker-options": _vm.pickerOptions,
                              placeholder: _vm.$t("basicData.SelectADatetime"),
                            },
                            model: {
                              value: _vm.formData.startOfValidityPeriod,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "startOfValidityPeriod",
                                  $$v
                                )
                              },
                              expression: "formData.startOfValidityPeriod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.businessT"),
                            prop: "businessType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                              },
                              on: { change: _vm.handleBusinessTypeChange },
                              model: {
                                value: _vm.formData.businessType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "businessType", $$v)
                                },
                                expression: "formData.businessType",
                              },
                            },
                            _vm._l(_vm.PAYABLE_TYPE, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.formData.businessType === 7
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.BusinessScenario"),
                                prop: "quoteType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  on: { change: _vm.changeQuoteType },
                                  model: {
                                    value: _vm.formData.quoteType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "quoteType", $$v)
                                    },
                                    expression: "formData.quoteType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: 1,
                                    attrs: {
                                      label: _vm.$t("mdfeTranslate.Entrega"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: 2,
                                    attrs: {
                                      label: _vm.$t("mdfeTranslate.Coleta"),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.businessType === 2 ||
                  _vm.formData.quoteType === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("collectionCenter.lanshouTypee"),
                                prop: "collectType",
                                rules: {
                                  required: true,
                                  message: _vm.$t("basicData.CannotBeEmpty"),
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "basicData.PleaseSelect"
                                    ),
                                  },
                                  on: { change: _vm.handleCollectTypeChange },
                                  model: {
                                    value: _vm.formData.collectType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "collectType", $$v)
                                    },
                                    expression: "formData.collectType",
                                  },
                                },
                                _vm._l(_vm.COLLECT_TYPE, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.shouldShowCargoType
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("placeOrder.cargoType"),
                                prop: "cargoType",
                                rules: _vm.getCargoTypeRules,
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "basicData.PleaseSelect"
                                    ),
                                  },
                                  model: {
                                    value: _vm.formData.cargoType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "cargoType", $$v)
                                    },
                                    expression: "formData.cargoType",
                                  },
                                },
                                _vm._l(_vm.CARGO_TYPE, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.shouldShowPartitionScheme
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.PartitionSchemeName"),
                                prop: "partitionId",
                                rules: {
                                  required: _vm.formData.businessType === 6,
                                  message: _vm.$t("basicData.CannotBeEmpty"),
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "basicData.PleaseSelect"
                                    ),
                                    filterable: "",
                                    clearable: "",
                                  },
                                  on: { change: _vm.handlePartitionChange },
                                  model: {
                                    value: _vm.formData.partitionId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "partitionId", $$v)
                                    },
                                    expression: "formData.partitionId",
                                  },
                                },
                                _vm._l(_vm.partitionList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isTransportationBusiness
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.transportType"),
                                prop: "transportType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "basicData.PleaseSelect"
                                    ),
                                  },
                                  on: { change: _vm.changeTransportType },
                                  model: {
                                    value: _vm.formData.transportType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "transportType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.transportType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.trunkLine"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.branchLine"),
                                      value: 2,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("collectionCenter.lanshou"),
                                      value: 3,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.CollectionFM"),
                                      value: 4,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isTransportationBusiness
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.QuotationType"),
                                prop: "quoteType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "basicData.PleaseSelect"
                                    ),
                                    disabled: _vm.formData.transportType === 4,
                                  },
                                  on: { change: _vm.changeQuotationType },
                                  model: {
                                    value: _vm.formData.quoteType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "quoteType", $$v)
                                    },
                                    expression: "formData.quoteType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "basicData.VehicleLineQuotation"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "basicData.GeneralQuotation"
                                      ),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.PayablePrincipal"),
                            prop: "payableEntityId",
                            rules: {
                              required: _vm.formData.businessType !== 2,
                              message: _vm.$t("basicData.CannotBeEmpty"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _vm.isTransportationBusiness
                            ? _c("ElSelectV2", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.transportationProviderList,
                                  filterable: "",
                                  size: "small",
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                },
                                on: { change: _vm.handleProviderChange },
                                model: {
                                  value: _vm.formData.payableEntityId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "payableEntityId",
                                      $$v
                                    )
                                  },
                                  expression: "formData.payableEntityId",
                                },
                              })
                            : _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: _vm.$t(
                                      "spareNumberPoo.Only10AreDisplayed"
                                    ),
                                    remote: "",
                                    clearable: "",
                                    "remote-method": _vm.handleProviderSearch,
                                  },
                                  on: { change: _vm.handleProviderChange },
                                  model: {
                                    value: _vm.formData.payableEntityId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "payableEntityId",
                                        $$v
                                      )
                                    },
                                    expression: "formData.payableEntityId",
                                  },
                                },
                                _vm._l(_vm.providerData, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label:
                                        item.providerBody +
                                        "（" +
                                        item.providerName +
                                        "）（" +
                                        item.code +
                                        "）",
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.shouldShowOutlets
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.Outlets"),
                                prop: "siteIds",
                              },
                            },
                            [
                              _c("ElSelectV2", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.outletsList,
                                  filterable: "",
                                  clearable: "",
                                  multiple: !_vm.editData.id,
                                  size: "small",
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                  "no-data-text": "无数据",
                                },
                                on: { change: _vm.handleSiteChange },
                                model: {
                                  value: _vm.formData.siteIds,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "siteIds", $$v)
                                  },
                                  expression: "formData.siteIds",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isAJDTransport
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.SettlementNode"),
                                prop: "settlementNode",
                                rules: {
                                  required: true,
                                  message: _vm.$t("basicData.CannotBeEmpty"),
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "basicData.PleaseSelect"
                                    ),
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.formData.settlementNode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "settlementNode",
                                        $$v
                                      )
                                    },
                                    expression: "formData.settlementNode",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.DeliveryTask"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.signFor"),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isPostalDeliveryBusiness
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "GlobalSetObj.ServiceProviderChannels"
                                    ),
                                    prop: "providerChannelId",
                                    rules: {
                                      required: true,
                                      message: _vm.$t(
                                        "basicData.CannotBeEmpty"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseSelectChannel"
                                        ),
                                      },
                                      model: {
                                        value: _vm.formData.providerChannelId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "providerChannelId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.providerChannelId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.ProviderChannelList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.providerChannelName,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.VolumeBilling"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "volume" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "",
                                            "label-width": "5px",
                                          },
                                        },
                                        [
                                          _c("el-checkbox", {
                                            attrs: {
                                              "false-label": 0,
                                              "true-label": 1,
                                            },
                                            model: {
                                              value:
                                                _vm.formData.useVolumeBilling,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "useVolumeBilling",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.useVolumeBilling",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "",
                                            "label-width": "5px",
                                            prop: "calculationMethod",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                width: "100px",
                                                "margin-left": "5px",
                                              },
                                              attrs: {
                                                disabled:
                                                  !_vm.formData
                                                    .useVolumeBilling,
                                                placeholder: _vm.$t(
                                                  "operationCenter.PleaseSelect"
                                                ),
                                              },
                                              model: {
                                                value:
                                                  _vm.formData
                                                    .calculationMethod,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "calculationMethod",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.calculationMethod",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: { value: 0, label: "*" },
                                              }),
                                              _c("el-option", {
                                                attrs: { value: 1, label: "/" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "",
                                            "label-width": "5px",
                                            prop: "calculateBase",
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: {
                                              "margin-left": "5px",
                                            },
                                            attrs: {
                                              controls: false,
                                              disabled:
                                                !_vm.formData.useVolumeBilling,
                                              max: 999999999,
                                              min: 0,
                                              placeholder: _vm.$t(
                                                "customerManagements.pleaseInput"
                                              ),
                                              precision: 2,
                                            },
                                            model: {
                                              value: _vm.formData.calculateBase,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "calculateBase",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.calculateBase",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("basicData.PriceDetails"))),
          ]),
          _c(
            "div",
            [
              _vm.formData.partitionId
                ? _c(
                    "div",
                    { staticClass: "flex mb10" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "el-form-item__label",
                          staticStyle: { "line-height": "32px" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("basicData.PartitionName")) +
                              "： "
                          ),
                        ]
                      ),
                      _c("QueryPartVCmp", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          val: _vm.formData.partitionAffiliateId,
                          list: _vm.subregionList,
                          clearable: false,
                        },
                        on: {
                          change: function (val) {
                            return (_vm.formData.partitionAffiliateId = val)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formData.businessType === 5 && _vm.formData.quoteType === 1
                ? _c(
                    "div",
                    { staticClass: "flex mb10" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "el-form-item__label",
                          staticStyle: { "line-height": "32px" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("basicData.routeName")) + "： "
                          ),
                        ]
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            filterable: "",
                            placeholder: _vm.$t("operationCenter.PleaseSelect"),
                            clearable: false,
                            size: "small",
                          },
                          model: {
                            value: _vm.formData.partitionAffiliateId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData,
                                "partitionAffiliateId",
                                $$v
                              )
                            },
                            expression: "formData.partitionAffiliateId",
                          },
                        },
                        _vm._l(_vm.stitchingLine, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.name + "（" + item.code + "）",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.shouldShowOperationButtons
                ? [
                    _c(
                      "div",
                      { staticClass: "mb10 feet-r" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value: "btn:payable:quoteManagement:addEdit",
                                expression:
                                  "'btn:payable:quoteManagement:addEdit'",
                                arg: "remove",
                              },
                            ],
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.handleAddRow },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("basicData.AddARow")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-start",
                              trigger: "hover",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "reference",
                                  fn: function () {
                                    return [
                                      _c(
                                        "el-button",
                                        { attrs: { size: "small", plain: "" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "basicData.ImportDownload"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1601201048
                            ),
                          },
                          [
                            _c("ImportDownload", {
                              key: _vm.exportKey,
                              attrs: {
                                "expense-type-list": _vm.expenseTypeList,
                                "table-data-obj": _vm.tableDataStructure,
                                "table-data": {
                                  formData: _vm.formData,
                                  subregionList: _vm.subregionList,
                                },
                              },
                              on: { importPartition: _vm.handleImportData },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-start",
                              trigger: "hover",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "reference",
                                  fn: function () {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "permit",
                                              rawName: "v-permit:remove",
                                              value:
                                                "btn:payable:quoteManagement:addEdit",
                                              expression:
                                                "'btn:payable:quoteManagement:addEdit'",
                                              arg: "remove",
                                            },
                                          ],
                                          attrs: { size: "small", plain: "" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "basicData.ClearTheOffer"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              118491624
                            ),
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "feet" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearOffers(1)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "basicData.EmptyCurrentPartition"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "feet-btn",
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clearOffers(2)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("basicData.EmptyAllPartitions")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm.isAnjunHouse
            ? [
                _c(
                  "el-form",
                  {
                    ref: "tableForm1",
                    staticClass: "error-form",
                    attrs: {
                      model: _vm.formData,
                      "label-width": "0",
                      "label-position": "top",
                      size: "mini",
                    },
                  },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.formData.collectFeesList,
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.ExpenseType"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("basicData.ExpenseType")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".feeTypeCode",
                                          rules: {
                                            required: true,
                                            message: _vm.$t(
                                              "basicData.CannotBeEmpty"
                                            ),
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "basicData.PleaseSelect"
                                              ),
                                            },
                                            model: {
                                              value: scope.row.feeTypeCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "feeTypeCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.feeTypeCode",
                                            },
                                          },
                                          _vm._l(
                                            _vm.expenseTypeList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label:
                                                    item.displayName +
                                                    "(" +
                                                    item.code +
                                                    ")",
                                                  value: item.code,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1719315232
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t(
                              "basicData.QuantityStartTicketNotIncluded"
                            ),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "basicData.QuantityStartTicketNotIncluded"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".startOfGoodsQuantity",
                                          rules: {
                                            required: true,
                                            suffix: "",
                                            negative: 2,
                                            negative1: 1,
                                            package:
                                              scope.row.endOfGoodsQuantity,
                                            validator: _vm.Integer0,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              scope.row.startOfGoodsQuantity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "startOfGoodsQuantity",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.startOfGoodsQuantity",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            362826094
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t(
                              "basicData.EndOfVolumeTicketIncluded"
                            ),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "basicData.EndOfVolumeTicketIncluded"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".endOfGoodsQuantity",
                                          rules: {
                                            required: true,
                                            suffix: "",
                                            negative: 1,
                                            negative1: 2,
                                            package:
                                              scope.row.startOfGoodsQuantity,
                                            validator: _vm.Integer0,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: scope.row.endOfGoodsQuantity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "endOfGoodsQuantity",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.endOfGoodsQuantity",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1791889889
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.PickUpPrice"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("basicData.PickUpPrice")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".price",
                                          rules: {
                                            required: true,
                                            suffix: 2,
                                            negative: "",
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: scope.row.price,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "price", $$v)
                                            },
                                            expression: "scope.row.price",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4049321778
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.logisticsSubsidy"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".subsidy",
                                          rules: {
                                            required: false,
                                            suffix: 2,
                                            negative: "",
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: scope.row.subsidy,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "subsidy",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.subsidy",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            869759068
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.operate"),
                            width: "120",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-popconfirm", {
                                      attrs: {
                                        title: _vm.$t(
                                          "basicData.AreYouSureYouWantToDelete"
                                        ),
                                      },
                                      on: {
                                        confirm: function ($event) {
                                          return _vm.handleDel(
                                            scope.$index,
                                            "collectFeesList"
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "danger",
                                                      size: "mini",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "basicData.Delete"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3549112552
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.isDspBusiness
            ? [
                _c(
                  "el-form",
                  {
                    ref: "tableForm1",
                    staticClass: "error-form",
                    attrs: {
                      model: _vm.formData,
                      "label-width": "0",
                      "label-position": "top",
                      size: "mini",
                    },
                  },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.formData.collectFeesList,
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.ExpenseType"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("basicData.ExpenseType")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".feeTypeCode",
                                          rules: _vm.expenseTypeRules,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "basicData.PleaseSelect"
                                              ),
                                            },
                                            model: {
                                              value: scope.row.feeTypeCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "feeTypeCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.feeTypeCode",
                                            },
                                          },
                                          _vm._l(
                                            _vm.expenseTypeList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label:
                                                    item.displayName +
                                                    "(" +
                                                    item.code +
                                                    ")",
                                                  value: item.code,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2514283767
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.WeightStartKG"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("basicData.WeightStartKG")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".startWeight",
                                          rules: {
                                            required: true,
                                            negative: "",
                                            suffix: 2,
                                            negative1: 1,
                                            package: scope.row.endWeight,
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: scope.row.startWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "startWeight",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.startWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3293801715
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.WeightEndKG"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("basicData.WeightEndKG")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".endWeight",
                                          rules: {
                                            required: true,
                                            negative: "",
                                            suffix: 2,
                                            negative1: 2,
                                            package: scope.row.startWeight,
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: scope.row.endWeight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "endWeight",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.endWeight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3171937392
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "0-31KM" + _vm.$t("basicData.Price"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("*")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            "0-31KM" + _vm.$t("basicData.Price")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".innerDistancePrice",
                                          rules: {
                                            required: true,
                                            suffix: 2,
                                            negative: "",
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: scope.row.innerDistancePrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "innerDistancePrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.innerDistancePrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1019532854
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "31-101KM" + _vm.$t("basicData.Price"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            "31-101KM" +
                                              _vm.$t("basicData.Price")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".outerDistancePrice",
                                          rules: {
                                            required: false,
                                            suffix: 2,
                                            negative: "",
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value: scope.row.outerDistancePrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "outerDistancePrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.outerDistancePrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3288795493
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: ">=101KM" + _vm.$t("basicData.Price"),
                            "min-width": "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            ">=101KM" +
                                              _vm.$t("basicData.Price")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".greaterThanDistancePrice",
                                          rules: {
                                            required: false,
                                            suffix: 2,
                                            negative: "",
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              scope.row
                                                .greaterThanDistancePrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "greaterThanDistancePrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.greaterThanDistancePrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            426638377
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label:
                              "0-31KM" +
                              _vm.$t("basicData.ExcessWeightFareIncrease"),
                            "min-width": "200",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          "0-31KM" +
                                            _vm.$t(
                                              "basicData.ExcessWeightFareIncrease"
                                            )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".overWeightExtraPrice",
                                          rules: {
                                            required: false,
                                            suffix: 2,
                                            negative: "",
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              scope.row.overWeightExtraPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "overWeightExtraPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.overWeightExtraPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            974907819
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label:
                              "31-101KM" +
                              _vm.$t("basicData.ExcessWeightFareIncrease"),
                            "min-width": "240",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          "31-101KM" +
                                            _vm.$t(
                                              "basicData.ExcessWeightFareIncrease"
                                            )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".overKilometerExtraPrice",
                                          rules: {
                                            required: false,
                                            suffix: 2,
                                            negative: "",
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              scope.row.overKilometerExtraPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "overKilometerExtraPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.overKilometerExtraPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            473224331
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label:
                              ">=101KM" +
                              _vm.$t("basicData.ExcessWeightFareIncrease"),
                            "min-width": "240",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          ">=101KM" +
                                            _vm.$t(
                                              "basicData.ExcessWeightFareIncrease"
                                            )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "collectFeesList." +
                                            scope.$index +
                                            ".greaterThanKilometerExtraPrice",
                                          rules: {
                                            required: false,
                                            suffix: 2,
                                            negative: "",
                                            validator: _vm.priceType,
                                            trigger: ["blur", "change"],
                                          },
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          model: {
                                            value:
                                              scope.row
                                                .greaterThanKilometerExtraPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "greaterThanKilometerExtraPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.greaterThanKilometerExtraPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2228895207
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("basicData.operate"),
                            width: "120",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-popconfirm", {
                                      attrs: {
                                        title: _vm.$t(
                                          "basicData.AreYouSureYouWantToDelete"
                                        ),
                                      },
                                      on: {
                                        confirm: function ($event) {
                                          return _vm.handleDelete(
                                            scope.$index,
                                            "collectFeesList"
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "reference",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "danger",
                                                      size: "mini",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "basicData.Delete"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            278633308
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.isCollectionForwardingCentreHomeDeliveryCmp
            ? _c("CollectionForwardingCentreHomeDeliveryCmp", {
                ref: "collectionForwardingCentreHomeDeliveryRef",
                attrs: {
                  "subregion-list": _vm.subregionList,
                  "partition-id": _vm.formData.partitionId,
                  "partition-affiliate-id": _vm.formData.partitionAffiliateId,
                },
              })
            : _vm._e(),
          _vm.isCollectionAndDoorToDoorCollectionAndThirdParty
            ? _c("CollectionAndDoorToDoorCollectionAndThirdPartyCmp", {
                ref: "collectionAndDoorToDoorCollectionAndThirdPartyRef",
                attrs: {
                  "subregion-list": _vm.subregionList,
                  "partition-id": _vm.formData.partitionId,
                  "partition-affiliate-id": _vm.formData.partitionAffiliateId,
                },
              })
            : _vm._e(),
          _vm.isBusinessType3AndOperationMode1
            ? _c("AJDAddCmp", {
                ref: "ajdAddRef",
                attrs: {
                  "subregion-list": _vm.subregionList,
                  "partition-id": _vm.formData.partitionId,
                  "partition-affiliate-id": _vm.formData.partitionAffiliateId,
                  "table-data": _vm.ajdRuleDataList,
                },
              })
            : _vm._e(),
          _vm.isTransportationBusiness
            ? _c("TransportationQuotation", {
                ref: "transportationQuotation",
                attrs: {
                  "model-list": _vm.modelList,
                  "stitching-line": _vm.stitchingLine,
                  "fee-type-list": _vm.expenseTypeList,
                  "quotation-type": _vm.formData.quoteType,
                  "partition-affiliate-id": _vm.formData.partitionAffiliateId,
                },
              })
            : _vm._e(),
          _vm.isPostalDeliveryBusiness
            ? _c("PostalDeliveryCmp", {
                ref: "PostalDeliveryCmpRef",
                attrs: {
                  "subregion-list": _vm.subregionList,
                  "partition-id": _vm.formData.partitionId,
                  "partition-affiliate-id": _vm.formData.partitionAffiliateId,
                  "fee-type-list": _vm.expenseTypeList,
                },
              })
            : _vm._e(),
          _vm.shouldShowOtherRules
            ? _c("OtherCmp", {
                ref: "otherRef",
                attrs: {
                  "subregion-list": _vm.subregionList,
                  "stitching-line": _vm.stitchingLine,
                  "special-fee-list": _vm.specialFeeList,
                  "business-type": _vm.formData.businessType,
                  "partition-id": _vm.formData.partitionId,
                  "partition-affiliate-id": _vm.formData.partitionAffiliateId,
                  ids: _vm.editData.id,
                  "quotation-type": _vm.formData.quoteType,
                  "data-list": _vm.otherRuleDataList,
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "addFooter" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v(" " + _vm._s(_vm.$t("basicData.Cancel")) + " ")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit:remove",
                  value: "btn:payable:quoteManagement:addEdit",
                  expression: "'btn:payable:quoteManagement:addEdit'",
                  arg: "remove",
                },
              ],
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("basicData.Save")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("basicData.tips"),
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "400",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm._l(_vm.errorMessages, function (item, ind) {
            return _c(
              "div",
              {
                key: ind,
                staticStyle: { color: "red", "margin-bottom": "8px" },
              },
              [_vm._v(" " + _vm._s(item) + " ")]
            )
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("basicData.determine")) + " ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }